import MD5 from 'md5';

export const hashJwtMd5 = () => {
	const jwt = localStorage.getItem('token') ?? '';
	const jwtHash = MD5(jwt);
	return jwtHash;
};
